<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  savingLabel="درحال تایید"
  saveLabel="تایید"
  reportName="HrmPayCurentYearMonthComponent"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="footer" *ngIf="formGroup">
    <ssg-button
      icon="icon-minus"
      buttontype="button"
      (click)="prevMonth()"
      class="login-btn"
      tooltip="ماه قبل"
      [disabled]="false"
      appearance="mini-btn"
      class="btnfooter">
    </ssg-button>
    <ssg-button
      icon="icon-plus-circle"
      buttontype="button"
      (click)="nextMonth()"
      class="login-btn"
      tooltip="ماه بعد"
      [disabled]="false"
      appearance="mini-btn"
      class="btnfooter">
    </ssg-button>
  </ng-container>
</dynamic-form>
